import '@fpsm/cxy-tokens/tokens.css';

import { type Logos } from '~/routes/$/constants/logos';

import { LogoImage } from '../LogoImage/LogoImage';

import styles from './LandingPageHeader.module.css';

export type LandingPageHeaderProps = {
  ctaText: string;
  ctaUrl: string;
  currentPathWithRepub: string;
  logo: Logos;
  logoUrl: string;
  resourcesUrl: string;
};

export const LandingPageHeader = ({
  ctaText,
  ctaUrl,
  currentPathWithRepub,
  logo,
  logoUrl,
  resourcesUrl,
}: LandingPageHeaderProps) => {
  const signupWidgetContainerElementId = ctaUrl;

  return (
    <header className={styles.header}>
      <a className={styles.logo} href={logoUrl}>
        <LogoImage logoName={logo} resourcesUrl={resourcesUrl} />
      </a>
      <a className={styles.cta} href={`${currentPathWithRepub}${signupWidgetContainerElementId}`}>
        {ctaText}
      </a>
    </header>
  );
};
